var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"elem_u_000778"}},[_c('v-file-input',{ref:"fileInput",staticClass:"d-none",attrs:{"accept":_vm.accept,"hide-input":"","data-testid":"elem_u_000779"},on:{"change":_vm.saveFile}}),_vm._t("default",null,{"on":{ click: _vm.open, upload: _vm.open }}),(_vm.requirementsError)?_c('PopupError',{ref:"popupError"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }